var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcDialog,{attrs:{"open":_vm.show,"name":_vm.t('settings', 'Choose Deploy Daemon for {appName}', { appName: _vm.app.name }),"size":"normal"},on:{"update:open":_setup.closeModal}},[_c(_setup.DaemonSelectionList,{attrs:{"app":_vm.app,"deploy-options":_vm.deployOptions},on:{"close":_setup.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }